// extracted by mini-css-extract-plugin
module.exports = {"scrollWrap":"scrollWrap--1Pzp8","scroll":"scroll--3H8Eh","item":"item--3fpzo","cl":"cl--11GYa"};